module.exports = __webpack_public_path__ + "static/media/quota-panel-filled.75c92d53.png";